import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { string } from "prop-types";

import { getSoriesBySlug } from "../../helper/api";
import PollCard from "../../molecules/PollCard";

import "./poll-counter.m.css";

const PollCounterPageBase = ({ lang }) => {
  const [pollStories, setPollStories] = useState([]);
  const [noPolls, setNoPolls] = useState(false);
  const ref = useRef(null);

  const getPollStoryElements = async (slug) => {
    const story = await getSoriesBySlug(slug);

    if (!story) {
      alert("Invalid slug");
    }

    const pollStories = [];

    story &&
      story.cards.forEach((card) =>
        card["story-elements"].forEach((element) => element.type === "polltype" && pollStories.push(element))
      );

    !pollStories.length && setNoPolls(true);
    setPollStories(pollStories);
  };

  const handlePolls = () => {
    const storyurl = ref.current.value;
    ref.current.value = "";

    setNoPolls(false);

    if (storyurl) {
      const urlArray = storyurl.split("/");

      if (urlArray.length > 1 && urlArray[0] === "https:") {
        getPollStoryElements(urlArray[urlArray.length - 1]);
      } else {
        return alert("Invalid url");
      }
    }
  };

  return (
    <>
      <div styleName={`base ${lang}-wrapper`}>
        <div styleName="text-area-wrapper">
          <input
            type="text"
            id="textarea"
            styleName="text-field"
            placeholder="Enter the Poll story URL here."
            ref={ref}
          />
          <button styleName="button" onClick={handlePolls}>
            Get poll count
          </button>
        </div>
        {noPolls && <div styleName="no-poll">No Polls Found!!</div>}
        {pollStories.length > 0 && (
          <div styleName="stories-wrapper">
            {pollStories.map((element, index) => (
              <PollCard polltypeId={element["polltype-id"]} key={index} index={index} lang={lang} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "bn"),
});

PollCounterPageBase.propTypes = {
  lang: string,
};

export const PollCounterPage = connect(mapStateToProps, null)(PollCounterPageBase);
